import gql from 'graphql-tag'

export const CREATE_HERO = gql`
  mutation CreateHero(
    $email: String
    $password: String!
    $heroType: HeroType!
    $name: String
    $firstname: String
    $lastname: String
    $tel: String!
    $address: String
    $subDistrict: String
    $district: String
    $province: String
    $zipcode: String
    $lineId: String
    $plateLicense: String
    $purpose: String
    $postalAddress: String
    $status: HeroStatus
  ) {
    createHero(
      data: {
        email: $email
        password: $password
        heroType: $heroType
        name: $name
        firstname: $firstname
        lastname: $lastname
        tel: $tel
        address: $address
        subDistrict: $subDistrict
        district: $district
        province: $province
        zipcode: $zipcode
        lineId: $lineId
        plateLicense: $plateLicense
        purpose: $purpose
        postalAddress: $postalAddress
        status: $status
      }
    ) {
      id
      name
      firstname
    }
  }
`

export const UPDATE_HERO_PROFILE = gql`
  mutation UpdateHero($id: Int!, $name: String, $email: String) {
    updateHero(id: $id, data: { name: $name, email: $email }) {
      id
      firstname
    }
  }
`

export const UPDATE_HERO = gql`
  mutation UpdateHero(
    $id: Int!
    $email: String
    $password: String
    $heroType: HeroType
    $name: String
    $firstname: String
    $lastname: String
    $tel: String
    $address: String
    $subDistrict: String
    $district: String
    $province: String
    $zipcode: String
    $lineId: String
    $plateLicense: String
    $purpose: String
    $postalAddress: String
    $status: HeroStatus
  ) {
    updateHero(
      id: $id
      data: {
        email: $email
        password: $password
        heroType: $heroType
        name: $name
        firstname: $firstname
        lastname: $lastname
        tel: $tel
        address: $address
        subDistrict: $subDistrict
        district: $district
        province: $province
        zipcode: $zipcode
        lineId: $lineId
        plateLicense: $plateLicense
        purpose: $purpose
        postalAddress: $postalAddress
        status: $status
      }
    ) {
      id
      name
      firstname
    }
  }
`

export const DELETE_HERO = gql`
  mutation DeleteHero($id: Int!) {
    deleteHero(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/Hero.js